import Vue from "vue";
const defaultTTL = 30;
const setToCache = (key, value, min = defaultTTL) => {
    const data = {
        ttl: Date.now() + (min || defaultTTL) * 60 * 1000,
        data: value
    };
    localStorage.setItem(`CACHE-${key}`, JSON.stringify(data));
    return value;
};

const getFromCache = key => {
    const data = localStorage.getItem(`CACHE-${key}`);
    if (data) {
        const decodeData = JSON.parse(data);
        if (Date.now() < decodeData.ttl) {
            // console.log(key, "loading from cache");
            return { status: true, data: decodeData.data };
        }
        localStorage.removeItem(`CACHE-${key}`);
    }
    return { status: false, data: null };
};
Vue.mixin({ methods: { setToCache, getFromCache } });
console.log("CACHE is ON");
